export const CURRENT_VERSION = "v0.2 BETA";
